<!-- eslint-disable max-len -->
<template>
  <li class="nav-item active">
    <div
      class="nav-link"
      href=""
      id="supportTicketMenu"
      role="button"
      @click="onNavButtonClicked"
      aria-expanded="false"
    >
      help
    </div>
    <b-modal
      ref="viewerModal"
      title="FAQ & Support Articles"
      hide-footer
      centered
      size="xl"
      content-class="details-modal-base"
      dialog-class="faq-modal"
      body-class="faq-modal-body"
    >
      <support-article-viewer in-modal></support-article-viewer>
    </b-modal>
  </li>
</template>

<script>
import { mapActions, mapGetters, } from 'vuex';
import SupportArticleViewer from './SupportArticleViewer';

export default {
  components: {
    SupportArticleViewer,
  },

  mounted() {
  },

  data() {
    return {
    };
  },

  computed: {
    ...mapGetters([
      'activeSignInConfig',
      'activeEnvironment',
      'canManageUsers',
      'me',
    ]),
    shouldUseSignInSettings() {
      return !(this.$route.meta && this.$route.meta.doNotUseSignInForNavbar)
        && ((this.$route.meta && this.$route.meta.useSignInForNavbar)
          || !(this.$route.path.startsWith('/groups/')));
    },
    useInternalHelp() {
      if (this.shouldUseSignInSettings) {
        const config = this.activeSignInConfig;
        if (config) {
          return config.useInternalHelp;
        }
      }
      return this.activeEnvironment.useInternalHelp;
    },
  },

  methods: {
    ...mapActions([
      'helpClickTracker'
    ]),
    async onNavButtonClicked() {
      if (this.$route.path.startsWith('/helpcenter')) {
        const newQueryParams = Object.assign({}, this.$route.query);
        newQueryParams.cat = undefined;
        newQueryParams.article = undefined;
        this.$router.push({ path: this.$route.path, query: newQueryParams });
      } else {
        this.$refs.viewerModal.show();
        await this.helpClickTracker();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar-root {
  height: 100%;
  padding-top: 4px;

  .nav-link {
    color: var(--navBarTextColor) !important;
    margin: 0 2px;
    // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    // text-transform: lowercase;
    font-weight: 100;
  }
  .nav-link:hover {
    // background-color: rgba(0, 0, 7, 0.2);
    background-color: var(--navBarHoverColor);
  }
}

.navbar-brand:focus, .nav-item a:focus {
  outline-color: white;
}

/deep/ .faq-modal-body {
  height: 90%;
}

/deep/ .details-modal-base {
  color: var(--faqTextColor);
  background-color: var(--faqBackgroundColor);
  height: 90vh;
}

/deep/ .faq-modal {
  width: 90% !important;
  max-width: 90% !important;
}

@media screen and (min-width: 320px) and (max-width: 767px) and (orientation: portrait) {
  /deep/ .details-modal-base {
    transform: rotate(-90deg);
    transform-origin: left top;
    width: calc(var(--detected-viewport-height) / 1.1);
    height: 97vw;
    overflow-x: visible;
    position: absolute;
    top: calc(var(--detected-viewport-height) / 1.05);
  }

  /deep/ .faq-modal {
    width: 98vh !important;
    max-width: 98vh !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/display/SupportArticleViewerModal.vue